import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArConnectApiKeyAddedApprovalAndPublishNotifyFollowersProps extends BaseTemplateProps {
  apiKeyName: string
}

export const ArConnectApiKeyAddedApprovalAndPublishNotifyFollowers: TemplateDefinition<ArConnectApiKeyAddedApprovalAndPublishNotifyFollowersProps> =
  {
    renderParams: (props: ArConnectApiKeyAddedApprovalAndPublishNotifyFollowersProps) => ({
      messageKey:
        'notificationsDomain.templates.arConnectApiKeyAddedApprovalAndPublishNotifyFollowers',
      values: { apiKeyName: props.apiKeyName },
    }),
  }
